export default {
  namespaced: true,
  state () {
    return {
      // 用于记录pageNo的，这样从其他页面返回数据时，会先查看它的结果
      indexPageNo: null,
      taskPageNo: null,
      rentPageNo: null,
      msConsignmentPageNo: null,
      eqConsignmentPageNo: null
    }
  },
  getters: {
  },
  mutations: {
    setIndexPageNo (state, obj) {
      state.indexPageNo = obj
    },
    setTaskPageNo (state, obj) {
      state.taskPageNo = obj
    },
    setRentPageNo (state, obj) {
      state.rentPageNo = obj
    },
    setMsConsignmentPageNo (state, obj) {
      state.msConsignmentPageNo = obj
    },
    setEqConsignmentPageNo (state, obj) {
      state.eqConsignmentPageNo = obj
    }
  },
  actions: {

  }
}
